export { flatten, getPersonDisplayName, mapProps } from '../utils/contentValues'
import Text from '../components/text.vue'
import List from '../components/list.vue'
import Blog from '../components/blog.vue'
import Faculty from '../components/faculty.vue'
import Course from '../components/course.vue'
import GenericCard from '../components/genericCard.vue'
import MyImage from '../components/myImage.vue'
import Thesis from '../components/thesis.vue'
import Video from '../components/video.vue'
import YouTubeVideo from '../components/youTubeVideo.vue'
import MyAccordian from '../components/myAccordian.vue'
import MyTabs from '../components/myTabs.vue'
import Event from '../components/event.vue'
import PdfViewer from '../components/pdfViewer.vue'
import Newsletter from '../components/newsletter.vue'
import Subjects from '../components/subjects.vue'
import TextPanel from '../components/textPanel.vue'

export const components: Record<string, any> = {
  Card: GenericCard,
  Image: MyImage,
  Text: Text,
  Hero: Text,
  FacultyPage: Faculty,
  CoursePage: Course,
  BlogPage: Blog,
  VideoPage: Video,
  ThesisPage: Thesis,
  NewsletterPage: Newsletter,
  EventPage: Event,
  YouTube: YouTubeVideo,
  List: List,
  Accordian: MyAccordian,
  Tabs: MyTabs,
  PDFViewer: PdfViewer,
  Subjects: Subjects,
  TextPanel: TextPanel,
}

export const deepClone = (obj: Record<string, any>) => {
  return JSON.parse(JSON.stringify(obj))
}

export const debounce = (fn: (...args: any[]) => void, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  return function (...args: any[]) {
    if (timeoutId) clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}


export const getTextClass = (webContentType: Record<string, any>) => {
  const textSize = webContentType?.title_size ? `text-${webContentType.title_size}` : ''
  const textColor = webContentType?.title_color ? `text-${webContentType.title_color}` : ''
  const textAlign = webContentType?.title_align ? `text-${webContentType.title_align}` : ''
  const textWeight = webContentType?.title_weight ? `font-${webContentType.title_weight}` : ''
  return [textSize, textColor, textAlign, textWeight]
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim()
}


export const isExternal = (url: string) => {
  return /^(https?:)?\/\//.test(url)
}
